// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2iWLj","fileBtn":"File_fileBtn__iesJY","closeBtn":"File_closeBtn__fkxWq","fileSelected":"File_fileSelected__2TEBX","disabled":"File_disabled__3Ic9f"};